// CUSTOM COMPONENT DatePickerEditFamilyField.tsx
import { useField, useFormikContext } from "formik";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import "dayjs/locale/es";

interface Props {
  name: string;
  label: string;
  required?: boolean;
}

export const DatePickerEditFamilyField = ({ name, label, required = false }: Props) => {
  const { setFieldValue } = useFormikContext<any>();
  const [field, meta] = useField(name);

  // 👇 si no hay valor, usamos la fecha de hoy como default
  const currentValue = field.value ? dayjs(field.value) : dayjs();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <DatePicker
        label={label}
        value={currentValue}
        onChange={(date) => {
          setFieldValue(name, date ? dayjs(date).toISOString() : null); 
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            required: required,
            error: Boolean(meta.touched && meta.error),
            helperText: meta.touched && meta.error ? meta.error : "",
          },
        }}
      />
    </LocalizationProvider>
  );
};
